import { initAuth } from "../../../redux/auth.reducer";
import api from "../../../utils/useApi";

const BasketOnClickEditAddress = async ({
  user,
  address,
  setStar,
  navigate,
  setSelectedLocation,
  selectedLocation,
  tempDetailAddress,
  detailAddress,

  dispatch,
}) => {
  // const myAddress =
  //   user?.address?.length > 0
  //     ? user?.address?.findIndex((row) => {
  //         return row?.place_id === address?.place_id;
  //       }) > -1
  //     : false;

  const myAddress =
    user?.address?.length > 0
      ? user?.address?.find((row) => {
          return row?.place_id === address?.place_id;
        })?._id
      : false;

  console.log("OUT : ", {
    myAddress,
    tempDetailAddress,
    detailAddress,
  });

  if (myAddress && tempDetailAddress !== detailAddress) {
    console.log("IN", myAddress);
    await api.put(`/address/${myAddress}`, {
      detail: detailAddress,
    });

    dispatch(initAuth());
  }

  // console.log("address", {
  //   address,
  //   myAddress,
  //   x: user?.address,
  // });
  // if (myAddress) {
  //   setStar(true);
  // } else {
  setStar(false);
  // }

  if (address) {
    setSelectedLocation({
      ...address,
      isAvailable: true,
    });
  }

  navigate("/Address");
};

export default BasketOnClickEditAddress;
